import { IApplicationState } from '../../../types/redux';

/**
 * Выбирает тэги
 */
export const selectTags = ({ tagsNew }: IApplicationState) => tagsNew;
